// extracted by mini-css-extract-plugin
export var hidden = "_um-0";